export const accountMenu = {
  roles: {
    collaborator: "Colaborador",
    hostMode: "Modo anfitrión",
  },
  header: {
    collaboratorAccess: "Acceso como colaborador",
  },
  panel: {
    label: "Vista del panel",
    apartment: "Apartamento",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Navegación",
    manage: "Gestión",
  },
  items: {
    home: "Inicio",
    bookings: "Reservas",
    myAccount: "Mi cuenta",
    myAccommodations: "Mis alojamientos",
    aiReception: "Recepción IA",
    aiReceptionist: "Recepción IA",
    directBookings: "Reservas directas",
    website: "Página web",
    logout: "Cerrar sesión",
  },
  badges: {
    ai: "IA",
    new: "NUEVO",
  },
  actions: {
    close: "Cerrar",
  },
};
